__turbopack_context__.v({
  "container": "TaxDeductionWidget-module-scss-module__R4UDsG__container",
  "cta": "TaxDeductionWidget-module-scss-module__R4UDsG__cta",
  "description": "TaxDeductionWidget-module-scss-module__R4UDsG__description",
  "desktopChart": "TaxDeductionWidget-module-scss-module__R4UDsG__desktopChart",
  "input": "TaxDeductionWidget-module-scss-module__R4UDsG__input",
  "mobileChart": "TaxDeductionWidget-module-scss-module__R4UDsG__mobileChart",
  "selectSum": "TaxDeductionWidget-module-scss-module__R4UDsG__selectSum",
  "suggestedSums": "TaxDeductionWidget-module-scss-module__R4UDsG__suggestedSums",
});
